interface StyleConfig {
  key: string;
  title: string;
  description: string;
  additionalProps?: Record<string, any>;
  wrapper?: string;
  wrapperProps?: Record<string, any>;
  gridExist?: boolean;
}

interface StyleLayoutItem {
  gridSize: { xs: number; md?: number };
  components: StyleConfig[];
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

export const previewAggregateSentimentAnalyticsStyleLayout: StyleLayoutItem[] = [
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'org_health_score',
        title: 'Organization Health Score',
        description: 'Overall interaction quality based on sentiment, engagement, and communication patterns',
        additionalProps: {
          dataKeys: ['score'],
          height: 450,
          graphHeight: 340,
          xAxisKey: 'date',
          colors: ['#5ebde9ff'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Health Score',
        },
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'sentiment_trend',
        title: 'Sentiment Distribution Comparison',
        description: 'Period-over-period comparison of positive, neutral, and negative sentiment distribution',
        additionalProps: {
          dataKeys: ['positive', 'neutral', 'negative'],
          height: 550,
          graphHeight: 330,
          xAxisKey: 'date',
          colors: ['#8cee96ff', '#2b6ac2b5', '#e63418ff'],
          xAxisTitle: 'Period',
          yAxisTitle: 'Percentage (%)',
          showLegend: true
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'call_volume',
        title: 'Call Volume Comparison',
        description: 'Call volume and completion rate compared to previous period',
        additionalProps: {
          dataKeys: ['total_calls', 'completed_calls'],
          height: 550,
          graphHeight: 350,
          xAxisKey: 'period',
          colors: ['#3b82f6', '#6366f1'],
          xAxisTitle: 'Period',
          yAxisTitle: 'Volume / Rate',
          stacked: false
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'risk_alerts',
        title: 'Calls Requiring Review',
        description: 'Calls flagged by AI for quality review with severity breakdown',
        additionalProps: {
          height: 350,
          graphHeight: 250,
        },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'emotion_heatmap',
        title: 'Emotion Heatmap by Day/Hour',
        description: 'When do interactions have the best/worst emotional quality?',
        additionalProps: {
          height: 600,
          graphHeight: 400,
          xAxisKey: 'hour',
          yAxisKey: 'day_name',
          valueKey: 'value',
          colorKey: 'color',
          tooltipKey: 'tooltip_text',
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date',
          colorLevels: [
            { label: 'Poor', color: '#ef4444', threshold: 0 },
            { label: 'Fair', color: '#f59e0b', threshold: 0.33 },
            { label: 'Good', color: '#84cc16', threshold: 0.67 },
            { label: 'Excellent', color: '#22c55e', threshold: 0.9 }
          ]
        },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'engagement_distribution',
        title: 'Engagement Score Distribution',
        description: 'Distribution of participant engagement levels across all calls',
        additionalProps: {
          height: 600,
          graphHeight: 370,
          xAxisKey: 'range',
          dataKeys: ['count'],
          colors: ['#7caaf4ff'],
          xAxisTitle: 'Engagement Score Range',
          yAxisTitle: 'Number of Calls',
          showValues: true
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'duration_quality',
        title: 'Duration vs Quality Analysis',
        description: 'Relationship between call duration and quality with quadrant classification',
        additionalProps: {
          height: 500,
          graphHeight: 280,
          xAxisKey: 'duration',
          yAxisKey: 'quality',
          quadrantKey: 'quadrant',
          tooltipKey: 'tooltip_text',
          xAxisTitle: 'Duration (minutes)',
          yAxisTitle: 'Quality Score',
          xAxisUnit: ' min',
          yAxisUnit: '',
          showZones: true,
          referenceLines: [
            { axis: 'y', value: 50, color: '#9CA3AF', label: 'Avg Quality' },
            { axis: 'x', value: 20, color: '#9CA3AF', label: 'Optimal Time' }
          ]
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'team_performance_top',
        title: 'Top Performing Teams',
        description: 'Teams with highest average interaction quality this period',
        additionalProps: {
          height: 450,
          rowHeight: 18
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'team_performance_bottom',
        title: 'Teams Needing Attention',
        description: 'Teams with declining or below-threshold interaction quality requiring coaching',
        additionalProps: {
          height: 450,
          rowHeight: 18
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'speech_behavior',
        title: 'Speech Behavior Summary',
        description: 'Org-wide averages: Talk balance • Interruption rate • Pause patterns',
        additionalProps: {

        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 12 },
    components: [
      {
        key: 'period_comparison',
        title: 'Period Comparison',
        description: 'Key metrics compared to previous period - Current vs Previous',
        additionalProps: {

        }
      }
    ]
  }
];